<template lang="pug">
page(
    main-title="Собственная доставка",
    :links="[{component: 'DeliveryServices', title: 'Службы доставки'}, `${mode.text} способа доставки`]"
)
    template(slot="description") {{ mode.text }} способа доставки 
        b {{ editedItem.name.value }}
    .panel
        .panel-body
            .row
                .col-md-6
                    field(
                        :item="editedItem.name",
                        label="Название"
                    )
                .col-md-6
                    .checkbox.clip-check.check-primary
                        input#only_for_promocode_input(
                            type="checkbox", 
                            v-model="editedItem.only_for_promocode"
                        )
                        label(for="only_for_promocode_input") Сделать доставку доступной только по <code>промокодам</code>
            .form-group
                template(v-if="mode.type === 'create'")
                    p.margin-bottom-0 Тип способа доставки: 
                    .radio.clip-radio.radio-primary.radio-inline
                        input#delivery_type_courier(type="radio", 
                                                    v-model="editedItem.delivery_type", 
                                                    value="courier")
                        label(for="delivery_type_courier") Курьер
                    .radio.clip-radio.radio-primary.radio-inline
                        input#delivery_type_pvz(type="radio", 
                                                v-model="editedItem.delivery_type", 
                                                value="pvz")
                        label(for="delivery_type_pvz") ПВЗ
                template(v-if="mode.type === 'update'") 
                    p.margin-bottom-0 Доставка 
                        code(v-if="editedItem.delivery_type === 'courier'") курьером
                        template(v-if="editedItem.delivery_type === 'pvz'") в 
                            code ПВЗ
                        | :
            template(v-if="editedItem.delivery_type === 'courier'",
                     v-for="(city, index) in editedItem.cities")
                .row.border-top.border-left.border-right.padding-top-10
                    .col-md-6
                        field(
                            type="select",
                            searchPath="/fias/autocomplete/",
                            :item="city.aoguid",
                            label="Населённый пункт"
                        )
                    .col-md-3
                        field(
                            type="number",
                            :item="city.delivery_price",
                            label="Стоимость, ₽"
                        )
                    .col-md-3
                        field(
                            type="number",
                            :item="city.delivery_days",
                            label=" Срок, дней"
                        )
                .row.border-left.border-right
                    .col-md-12
                        .checkbox.clip-check.check-primary.checkbox-inline
                            input(
                                :id="`online_payment_${index}`"
                                type="checkbox", 
                                v-model="city.online_payment"
                            )
                            label(:for="`online_payment_${index}`") Оплата онлайн
                        .checkbox.clip-check.check-primary.checkbox-inline
                            input(
                                :id="`cash_payment_${index}`"
                                type="checkbox", 
                                v-model="city.cash_payment"
                            )
                            label(:for="`cash_payment_${index}`") Оплата наличными
                        .checkbox.clip-check.check-primary.checkbox-inline
                            input(
                                :id="`card_payment_${index}`"
                                type="checkbox", 
                                v-model="city.card_payment"
                            )
                            label(:for="`card_payment_${index}`") Оплата картой
                .row.margin-bottom-10.border-bottom.border-left.border-right
                    .col-md-12
                        p(v-if="!index") Ограничения по параметрам <b>товара</b> (если нет – не заполняйте):
                    div(:class="editedItem.cities.length > 1 ? 'col-md-3' : 'col-md-4'")
                        field(
                            type="number",
                            :item="city.max_x"
                            label="Максимальная длина, см"
                        )
                    div(:class="editedItem.cities.length > 1 ? 'col-md-3' : 'col-md-4'")
                        field(
                            type="number",
                            :item="city.max_y"
                            label="Максимальная ширина, см"
                        )
                    div(:class="editedItem.cities.length > 1 ? 'col-md-3' : 'col-md-4'")
                        field(
                            type="number",
                            :item="city.max_z"
                            label="Максимальная высота, см"
                        )
                    div(:class="editedItem.cities.length > 1 ? 'col-md-3' : 'col-md-4'")
                        field(
                            type="number",
                            :item="city.max_weight",
                            label="Максимальный вес, грамм"
                        )
                    div(:class="editedItem.cities.length > 1 ? 'col-md-3' : 'col-md-4'")
                        field(
                            type="number",
                            :item="city.max_price",
                            label="Максимальная стоимость, ₽"
                        )
                    .col-md-3(v-if="editedItem.cities.length > 1")
                        button.btn.btn-default(@click="removeCity(city)") Удалить населённый пункт
            template(v-else-if="editedItem.delivery_type === 'pvz'")
                .row.margin-bottom-30
                    .col-md-12
                        p(v-for="pvz in editedItem.pvzs") 
                            a(@click.prevent="editPvz(pvz)") {{ pvz.unique_id }}
                            |  {{ pvz.city.formalname }}, {{ pvz.address }}
            button.btn.btn-o.btn-primary(@click.prevent="save") Сохранить
            button.btn.btn-default.margin-left-4(
                v-if="editedItem.delivery_type === 'courier'",
                @click='addCity'
            ) Добавить населённый пункт
            button.btn.btn-o.btn-default.margin-left-4(
                v-if="editedItem.delivery_type === 'pvz'",
                @click="editPvz({})"
            ) Добавить ПВЗ
            button.btn.btn-o.btn-danger.margin-left-4(
                v-if="mode.type === 'update'",
                @click.prevent="remove"
            ) Удалить
            button.btn.btn-o.btn-primary.pull-right(@click.prevent="discard") Отмена
</template>

<script>
import Field from '@/components/core/Field';

import cloneDeep from 'lodash/cloneDeep';

const editedCourierFields = [
    {name: 'name', required: true},
    {name: 'cities',
        subfields: [
        {name: 'aoguid', required: true},
        {name: 'delivery_price', required: true},
        {name: 'delivery_days', required: true},
        {name: 'max_x'},
        {name: 'max_y'},
        {name: 'max_z'},
        {name: 'max_weight'},
        {name: 'max_price'}
        ]}
];
const editedPvzFields = [
    {name: 'name', required: true}
];

export default {
    name: 'EditManualDeliveryMethod',
    components: {
        Field
    },
    created() {
        if (this.editedItem.id) {
            this.$store.dispatch('loadManualDeliveryMethod')
                .then(item => {
                    this.editedItem = this.getInitial();
                });
        }
    },
    methods: {
        save() {
            if (this.validate()) {
                this.$store.dispatch('saveManualDM', this.getValues())
                    .then(() => {
                        this.$router.push({name: 'DeliveryServices'});
                    });
            }
        },
        validate() {
            let valid = true;
            for (let field of this.editedFields) {
                if (field.name === 'cities') {
                    for (let city of this.editedItem.cities) {
                        for (let subfield of field.subfields) {
                            if (subfield.required && !city[subfield.name].value && city[subfield.name].value !== 0) {
                                city[subfield.name].valid = valid = false;
                                city[subfield.name].message = 'Обязательно для заполнения';
                            }
                            if (['max_weight', 'max_x', 'max_y', 'max_z', 'max_price'].includes(subfield.name) &&
                                    [0, '0'].includes(city[subfield.name].value)) {
                                city[subfield.name].valid = valid = false;
                                city[subfield.name].message = 'Ноль – не лучшее значение для этого поля, оно отрежет все товары';
                            }
                        }
                    }
                } else if (field.required && !this.editedItem[field.name].value) {
                    this.editedItem[field.name].valid = valid = false;
                    this.editedItem[field.name].message = 'Обязательно для заполнения';
                }
            }
            return valid;
        },
        remove() {
            this.$store.dispatch('removeManualDM', this.editedItem.id)
                .then(() => {
                    this.$router.push({name: 'DeliveryServices'});
                });
        },
        discard() {
            this.$router.push({name: 'DeliveryServices'});
        },
        editPvz(pvz) {
            if (this.validate()) {
                this.$store.dispatch('saveManualDM', this.getValues())
                    .then(() => {
                        this.$store.commit('selectEditedPvz', pvz);
                        this.$router.push({name: 'EditManualPvz'});
                    });
            }
        },
        getValues() {
            let values = cloneDeep(this.editedItem);

            for (let field of this.editedFields) {
                if (field.subfields) {
                    for (let city of values.cities) {
                        for (let subfield of field.subfields) {
                            if (subfield.name !== 'aoguid') {
                                city[subfield.name] = city[subfield.name].value;
                            } else {
                                city.aoguid = city.aoguid.value.aoguid;
                            }
                        }
                    }
                } else {
                    values[field.name] = values[field.name].value;
                }
            }

            return values;
        },
        getInitial() {
            let item = cloneDeep(this.$store.state.deliveryServices.editedManualDeliveryMethod);

            if (!item.delivery_type) {
                item.delivery_type = 'courier';
            }
            if (!item.only_for_promocode) {
                item.only_for_promocode = false;
            }
            if (!item.cities || !item.cities.length) {
                item.cities = [{
                    aoguid: null,
                    delivery_days: null,
                    delivery_price: null,
                    online_payment: false,
                    cash_payment: false,
                    card_payment: false,
                    max_weight: null,
                    max_price: null,
                    max_x: null,
                    max_y: null,
                    max_z: null
                }];
            }

            let editedFields = this.editedFields;
            if (!editedFields) {
                editedFields = item.delivery_type === 'courier'
                    ? editedCourierFields : editedPvzFields;
            }

            for (let field of editedFields) {
                if (field.subfields) {
                    for (let city of item.cities) {
                        for (let subfield of field.subfields) {
                            city[subfield.name] = {
                                value: city[subfield.name],
                                valid: true,
                                message: null
                            };
                        }
                    }
                } else {
                    item[field.name] = {
                        value: item[field.name],
                        valid: true,
                        message: null
                    };
                }
            }
            return item;
        },
        addCity() {
            this.editedItem.cities.push({
                aoguid: {value: null, valid: true, message: null},
                delivery_days: {value: null, valid: true, message: null},
                delivery_price: {value: null, valid: true, message: null},
                online_payment: false,
                cash_payment: false,
                card_payment: false,
                max_x: {value: null, valid: true, message: null},
                max_y: {value: null, valid: true, message: null},
                max_z: {value: null, valid: true, message: null},
                max_weight: {value: null, valid: true, message: null},
                max_price: {value: null, valid: true, message: null}

            });
        },
        removeCity(city) {
            this.editedItem.cities.splice(
                this.editedItem.cities.findIndex(i => i === city), 1
            );
        }
    },
    computed: {
        mode() {
            return {
                text: this.editedItem.id ? 'Редактирование' : 'Создание',
                type: this.editedItem.id ? 'update' : 'create'
            };
        },
        editedFields() {
            return this.editedItem.delivery_type === 'pvz' ? editedPvzFields : editedCourierFields;
        }
    },
    data() {
        return {
            editedItem: this.getInitial()
        };
    }
};
</script>



// WEBPACK FOOTER //
// src/components/deliveryServices/EditManualDeliveryMethod.vue